
module.exports = {

    methods: {
        selectUser(user) {
            var information = '';
        
            var properties = ['Name', 'Company', 'Email', 'Website', 'Phone', 'Address'];
        
            console.log(user)
            for (var property in properties) {
                if (user[properties[property].toLowerCase()] && user[properties[property].toLowerCase()] != '') {
                    information += `<tr>
                        <th>${properties[property]}:</th>
                        <td>`
                    if (properties[property] == 'Phone') {
                        information += `<a href="tel:${user[properties[property].toLowerCase().replace(/-|\s/g, "")]}">
                                                    ${user[properties[property].toLowerCase()]}
                                                </a>`
                    } else {
                        information += user[properties[property].toLowerCase()]
                    }
                    information += `</td>
                    </tr>`;
                }
            }
        
            Alert.text('Contact Information', `
                <table class="table table-striped text-left" style="border: 1px solid #dee2e6">
                    ${information}
                </table>
                `);
        }
    }
}